import { HistoryDetail } from 'scenes/common/flows/policyDetails/types';
import { YesNoAnswer } from 'scenes/common/types';
import { PolicyOtherOptionName, WireHistory, WireNameValue } from '../types';
import { DIFFERENT_ADDRESS_ID } from './ids';

export const toWireOnlineDiscount = (): WireNameValue[] => [
  {
    name: PolicyOtherOptionName.OnlineDiscount,
    value: 'true',
  },
];

export const toWireEmailOptIn = (): WireNameValue[] => [
  {
    name: PolicyOtherOptionName.EmailOptIn,
    value: 'true',
  },
];

export const toWireSaveQuoteEmailAddress = (
  emailAddress: string
): WireNameValue => ({
  name: PolicyOtherOptionName.Notification,
  value: emailAddress.trim(),
});

export const toWireAgreedTc = (
  hasAgreedTermsAndConditions: boolean
): WireNameValue[] =>
  hasAgreedTermsAndConditions
    ? [
        {
          name: PolicyOtherOptionName.TCAccept,
          value: 'true',
        },
      ]
    : [];

export const toWirePromoCode = (promoCode: string): WireNameValue[] =>
  promoCode?.length > 2
    ? [
        {
          name: PolicyOtherOptionName.PromoCode,
          value: promoCode,
        },
      ]
    : [];

export const toWireMarketingConsent = (
  marketingConsent: YesNoAnswer
): WireNameValue[] =>
  marketingConsent
    ? [
        {
          name: PolicyOtherOptionName.MarketingConsent,
          value: marketingConsent === YesNoAnswer.Yes ? 'true' : 'false',
        },
      ]
    : [];

export const toUsedDifferentAddress = (
  differentAddress: boolean
): WireNameValue[] =>
  differentAddress
    ? [
        {
          name: PolicyOtherOptionName.UsedDifferentAddress,
          value: DIFFERENT_ADDRESS_ID,
        },
      ]
    : [];

export const toWireHistory = (
  insurer: string,
  hasBreakInClaims: boolean,
  historyDetails: HistoryDetail[]
): WireHistory => ({
  insurer,
  hasBreakInClaims,
  hasClaimRefused: historyDetails.includes(HistoryDetail.InsuranceClaimRefused),
  hasInsuranceDenied: historyDetails.includes(HistoryDetail.DeniedPurchase),
  hasConviction: historyDetails.includes(HistoryDetail.ConvictedBurglary),
  otherOffence: historyDetails.includes(HistoryDetail.ConvictedCriminalOffence),
});
